import filterCommentFilter from 'common/filters/filterCommentFilter'
import filterParagraphRates from 'common/filters/filterParagraphRates'
import type { CommonContextStore } from 'src/types/context'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'
import highlightReviewTags from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/highlightReviewTags'

export type CommentField = 'comment' | 'comment_plus' | 'comment_minus' | 'text'

export type CommentSection = {
  field: CommentField
  title: string
  html: string
}

/**
 * HTML тела отзыва для `v-html`.
 *
 * Сначала подсветка тегов, затем фильтры абзацев и разметки комментария.
 * Пустая строка, если перевода поля нет: секция в карточке тогда не рендерится.
 */
export function getCommentHtml(
  rate: Rate,
  field: CommentField,
  context: CommonContextStore['context'],
): string {
  const text = tDynamic(rate, field)

  if (!text) {
    return ''
  }

  const tagged = highlightReviewTags(text, rate, context)

  return filterParagraphRates(filterCommentFilter(tagged))
}

/**
 * Секции текста карточки в порядке отображения.
 *
 * У `simple` / `photo` одно поле `text`; у подробного — история, плюсы и минусы.
 * Аннулированный отзыв без секций: вместо текста показывается алерт.
 */
export function getCommentSections(
  rate: Rate,
  context: CommonContextStore['context'],
): CommentSection[] {
  if (rate.is_refuted) {
    return []
  }

  if (rate.ratetype === 'simple' || rate.ratetype === 'photo') {
    const html = getCommentHtml(rate, 'text', context)

    return html
      ? [{ field: 'text', title: tStatic('История пациента'), html }]
      : []
  }

  const fields: Array<{ field: CommentField, title: string }> = [
    { field: 'comment', title: tStatic('История пациента') },
    { field: 'comment_plus', title: tStatic('Понравилось') },
    { field: 'comment_minus', title: tStatic('Не понравилось') },
  ]

  return fields.flatMap(({ field, title }) => {
    const html = getCommentHtml(rate, field, context)

    return html ? [{ field, title, html }] : []
  })
}

/**
 * Текст дополнения без подсветки тегов: у supplement нет `ratetag_set`.
 */
export function getSupplementHtml(supplement: { text?: string, translations?: Record<string, unknown> }): string {
  return tDynamic(supplement, 'text')
}
